import React from 'react';

/**
 * Show is a component-method alternative of 'inline-if-logical-operators', such
 * as
 * https://reactjs.org/docs/conditional-rendering.html#inline-if-with-logical--operator
 *
 * However, as this is technically a component, this will break any parent
 * components modifying the props of a child component, such as RadioGroup. Use
 * inline expressions for those instances.
 *
 * @deprecated - Use inline-if-logical-operators instead. https://reactjs.org/docs/conditional-rendering.html#inline-if-with-logical--operator
 *
 * When this component is used, you cannot successfully test using Shallow.
 */
export default function Show(props) {
  if (props.when && props.children) {
    const okayRaw = ['[object Function]', '[object Object]'];
    if (okayRaw.includes(Object.prototype.toString.call(props.children))) {
      return props.children;
    }

    // Typically if `children` is an Array it will throw an exception
    return <span>{props.children}</span>;
  }

  return null;
}
